document.querySelectorAll('[data-input="textarea"]').forEach(textarea => {
  textarea.addEventListener('input', () => {
    textarea.style.height = '28px';
    textarea.style.height = textarea.scrollHeight + 'px';
  });
})
